import { useEffect, useLayoutEffect, useState } from 'react';

const ENV = {
  tablet: 720,
  phone: 576,
  pc: 1200,
};

// const BootstrapSize = {
//   xs: "",
//   sm: "",
//   md: "",
//   lg: "",
//   xl: "",
// };

export default function useWindowSize({ baseOn = 'window', id }) {
  const [size, setSize] = useState([0, 0]);

  function updateSize() {
    if (baseOn === 'window') {
      setSize([
        window.innerWidth,
        window.innerHeight,
        findEnv(window.innerWidth),
        findBootstrapSize(window.innerWidth),
      ]);
    } else {
      const elem = document.getElementById(id);
      if (elem) {
        setSize([
          elem.offsetWidth,
          elem.offsetHeight,
          findEnv(elem.offsetWidth),
          findBootstrapSize(elem.offsetWidth),
        ]);
      } else {
        setSize([
          window.innerWidth,
          window.innerHeight,
          findEnv(window.innerWidth),
          findBootstrapSize(window.innerWidth),
        ]);
      }
    }
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
    
  }, []);

  useEffect(() => {
    if (size[0]) {
      const currentSize = [...size];
      currentSize[2] = findEnv(size[0]);
      setSize(currentSize);
    }
    
  }, [size[0]]);

  return {
    width: size[0],
    height: size[1],
    env: size[2],
    bootstrapSize: size[3],
  };
}

export function getWidthSize(baseOn: string, id?: string | null) {
  if (baseOn === 'window') {
    return window.innerWidth;
  } else {
    if (id) {
      const elem = document.getElementById(id);
      if (elem) {
        return elem.offsetWidth;
      } else {
        return window.innerWidth;
      }
    }
    return window.innerWidth;
  }
}

export function findEnv(width) {
  // const width = windowSize.windowWidth;
  let env;
  if (width > ENV.tablet) {
    env = 'pc';
  } else if (width > ENV.phone && width <= ENV.tablet) {
    env = 'tablet';
  } else if (width <= ENV.phone) {
    env = 'phone';
  }
  return env;
}

export function findBootstrapSize(width) {
  if (width < 576) {
    return 'xs';
  }
  if (width >= 576 && width < 768) {
    return 'sm';
  }
  if (width >= 768 && width < 992) {
    return 'md';
  }
  if (width >= 992 && width < 1200) {
    return 'lg';
  }
  if (width >= 1200) {
    return 'xl';
  }
}

export function getBootstrapValue(baseOn, id) {
  return findBootstrapSize(getWidthSize(baseOn, id));
}

export function vhToPx(vh) {
  const size = vh ? vh.split('vh')[0] : '';
  return size ? (document.documentElement.clientHeight * size) / 100 : '';
}
